import React from "react";
import { Trans } from "react-i18next";
import { useQueryParams, useTranslation } from "hooks";
import ErrorMessage from "../../../../components/errors/error-message";
import fixing from "../../../../components/errors/error-boundary/assets/fixing.mp4";

const SUPPORT_URL = "https://acceleratelearning.com/contact/";

const AccessDeniedMessage: React.FC = () => (
  <Trans
    i18nKey="lti.errorAccessDenied"
    components={{
      1: (
        <strong style={{ fontWeight: 800 }}>
          {/* children injected by Trans */}
        </strong>
      ),
      2: (
        <a
          href={SUPPORT_URL}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "var(--primary-600)" }}
        >
          {/* children injected by Trans */}
        </a>
      ),
      3: (
        <strong style={{ fontWeight: 800 }}>
          {/* children injected by Trans */}
        </strong>
      ),
    }}
  />
);

const AccessDeniedMessageAlternative: React.FC = () => (
  <Trans
    i18nKey="lti.errorAccessDeniedAlternative"
    components={{
      1: (
        <a
          href={SUPPORT_URL}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "var(--primary-600)" }}
        >
          {/* children injected by Trans */}
        </a>
      ),
      2: (
        <strong style={{ fontWeight: 800 }}>
          {/* children injected by Trans */}
        </strong>
      ),
    }}
  />
);

const ErrorScreen: React.FC = () => {
  const { t } = useTranslation();
  const [params] = useQueryParams();
  const errorCode = (params.get("code") as string) || "";

  const isAccessDenied = errorCode === "LTI Error - 35";
  const isAccessDeniedAlternative = errorCode === "LTI Error - 36";

  let errorAltMessage = t("lti.error", { code: "" });
  let errorDescription: string | React.JSX.Element = t("lti.error", {
    code: "",
  });
  if (isAccessDenied) {
    errorAltMessage = t("lti.errorAccessDenied");
    errorDescription = <AccessDeniedMessage />;
  } else if (isAccessDeniedAlternative) {
    errorAltMessage = t("lti.errorAccessDeniedAlternative");
    errorDescription = <AccessDeniedMessageAlternative />;
  } else if (errorCode) {
    errorAltMessage = t("lti.error", { code: `#${errorCode}` });
    errorDescription = t("lti.error", { code: `#${errorCode}` });
  }

  return (
    <ErrorMessage
      description={errorDescription}
      alt={errorAltMessage}
      /* eslint-disable-next-line jsx-a11y/media-has-caption */
      asset={<video autoPlay loop muted src={fixing} />}
    />
  );
};

export default ErrorScreen;
